// extracted by mini-css-extract-plugin
module.exports = {"globalCollapseThreshold":"1370px"};